// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as ModalBody from "../../../../library/reuseable-components/ModalBody.bs.js";
import * as Belt_Result from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ModalFooter from "../../../../library/reuseable-components/ModalFooter.bs.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingUtils from "../../../../library/utils/CorePricingUtils.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PricingDashboardConfig from "../../../../library/utils/PricingDashboardConfig.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as FormValidationUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.bs.js";

function SimpleModificationBaseDetailsForm$BaseDetailInput(Props) {
  var sign = Props.sign;
  var delta = Props.delta;
  var value = Props.value;
  var label = Props.label;
  var changeSign = Props.changeSign;
  var changeDelta = Props.changeDelta;
  var result = Props.result;
  var tmp;
  tmp = result !== undefined && result.TAG !== /* Ok */0 ? result._0 : null;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-modification-base-detail-input"
            }, label, React.createElement("div", {
                  className: "input-error-section"
                }, React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "input-section"
                    }, React.createElement("div", {
                          className: "sign " + (
                            sign === /* Increment */0 ? " selected" : ""
                          ),
                          onClick: (function (param) {
                              return Curry._1(changeSign, /* Increment */0);
                            })
                        }, "+"), React.createElement("div", {
                          className: "sign " + (
                            sign === /* Decrement */1 ? " selected" : ""
                          ),
                          onClick: (function (param) {
                              return Curry._1(changeSign, /* Decrement */1);
                            })
                        }, "-"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._1(changeDelta, FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: delta
                          }
                        }), React.createElement("div", {
                          className: "value-box " + (
                            delta === "0" ? "" : (
                                sign === /* Decrement */1 ? " negative" : " positive"
                              )
                          )
                        }, value)), React.createElement("div", {
                      className: "error-container"
                    }, tmp)));
}

var BaseDetailInput = {
  make: SimpleModificationBaseDetailsForm$BaseDetailInput
};

var validators_free_km_price = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var free_km_price = param.free_km_price;
      return Belt_Result.flatMap(CorePricingUtils.validatePositiveFloat(free_km_price.delta), (function (p) {
                    var price = free_km_price.sign === /* Increment */0 ? p : -1.0 * p;
                    if (price + free_km_price.base_value < 0.0 || price + free_km_price.base_value > PricingDashboardConfig.free_km_price_lmit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Total value should be between 0 and 25"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Currency.toCurrency(price)
                            };
                    }
                  }));
    })
};

var validators_free_kms = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var free_kms = param.free_kms;
      return Belt_Result.flatMap(CorePricingUtils.getWholeNumberValue(free_kms.delta), (function (k) {
                    var kms = free_kms.sign === /* Increment */0 ? k : Math.imul(-1, k);
                    if ((kms + free_kms.base_value | 0) < 0 || (kms + free_kms.base_value | 0) > PricingDashboardConfig.free_kms_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Enter values between 0 and 20"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: kms
                            };
                    }
                  }));
    })
};

var validators_waiting_rate_per_min = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var waiting_rate_per_min = param.waiting_rate_per_min;
      return Belt_Result.flatMap(CorePricingUtils.validatePositiveFloat(waiting_rate_per_min.delta), (function (r) {
                    var rate = waiting_rate_per_min.sign === /* Increment */0 ? r : -1.0 * r;
                    if (rate + waiting_rate_per_min.base_value < 0.0 || rate + waiting_rate_per_min.base_value > PricingDashboardConfig.waiting_rate_per_min_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Total value should be between 0 and 25"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Currency.toCurrency(rate)
                            };
                    }
                  }));
    })
};

var validators_free_duration = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var free_duration = param.free_duration;
      return Belt_Result.flatMap(CorePricingUtils.getWholeNumberValue(free_duration.delta), (function (d) {
                    var duration = free_duration.sign === /* Increment */0 ? d : Math.imul(-1, d);
                    if ((duration + free_duration.base_value | 0) < 0 || (duration + free_duration.base_value | 0) > PricingDashboardConfig.free_duration_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Total value should be between 0 and 300"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: duration
                            };
                    }
                  }));
    })
};

var validators_base_fare = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var base_fare = param.base_fare;
      return Belt_Result.flatMap(CorePricingUtils.validatePositiveFloat(base_fare.delta), (function (f) {
                    var fare = base_fare.sign === /* Increment */0 ? f : -1.0 * f;
                    if (fare + base_fare.base_value < 0.0 || fare + base_fare.base_value > PricingDashboardConfig.base_fare_limit) {
                      return {
                              TAG: /* Error */1,
                              _0: "Total value must be within valid range"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Currency.toCurrency(fare)
                            };
                    }
                  }));
    })
};

var validators = {
  free_km_price: validators_free_km_price,
  free_kms: validators_free_kms,
  waiting_rate_per_min: validators_waiting_rate_per_min,
  free_duration: validators_free_duration,
  base_fare: validators_base_fare
};

function initialFieldsStatuses(_input) {
  return {
          free_km_price: /* Pristine */0,
          free_kms: /* Pristine */0,
          waiting_rate_per_min: /* Pristine */0,
          free_duration: /* Pristine */0,
          base_fare: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.free_km_price;
  var match_0 = match ? match._0 : Curry._1(validators.free_km_price.validate, input);
  var match$1 = fieldsStatuses.free_kms;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.free_kms.validate, input);
  var match$2 = fieldsStatuses.waiting_rate_per_min;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.waiting_rate_per_min.validate, input);
  var match$3 = fieldsStatuses.free_duration;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.free_duration.validate, input);
  var match$4 = fieldsStatuses.base_fare;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.base_fare.validate, input);
  var free_km_priceResult = match_0;
  var free_km_priceResult$1;
  if (free_km_priceResult.TAG === /* Ok */0) {
    var free_kmsResult = match_0$1;
    if (free_kmsResult.TAG === /* Ok */0) {
      var waiting_rate_per_minResult = match_0$2;
      if (waiting_rate_per_minResult.TAG === /* Ok */0) {
        var free_durationResult = match_0$3;
        if (free_durationResult.TAG === /* Ok */0) {
          var base_fareResult = match_0$4;
          if (base_fareResult.TAG === /* Ok */0) {
            return {
                    TAG: /* Valid */0,
                    output: {
                      base_fare: base_fareResult._0,
                      free_duration: free_durationResult._0,
                      waiting_rate_per_min: waiting_rate_per_minResult._0,
                      free_kms: free_kmsResult._0,
                      free_km_price: free_km_priceResult._0
                    },
                    fieldsStatuses: {
                      free_km_price: /* Dirty */{
                        _0: free_km_priceResult,
                        _1: /* Shown */0
                      },
                      free_kms: /* Dirty */{
                        _0: free_kmsResult,
                        _1: /* Shown */0
                      },
                      waiting_rate_per_min: /* Dirty */{
                        _0: waiting_rate_per_minResult,
                        _1: /* Shown */0
                      },
                      free_duration: /* Dirty */{
                        _0: free_durationResult,
                        _1: /* Shown */0
                      },
                      base_fare: /* Dirty */{
                        _0: base_fareResult,
                        _1: /* Shown */0
                      }
                    },
                    collectionsStatuses: undefined
                  };
          }
          free_km_priceResult$1 = free_km_priceResult;
        } else {
          free_km_priceResult$1 = free_km_priceResult;
        }
      } else {
        free_km_priceResult$1 = free_km_priceResult;
      }
    } else {
      free_km_priceResult$1 = free_km_priceResult;
    }
  } else {
    free_km_priceResult$1 = free_km_priceResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            free_km_price: /* Dirty */{
              _0: free_km_priceResult$1,
              _1: /* Shown */0
            },
            free_kms: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            waiting_rate_per_min: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            free_duration: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            base_fare: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurFree_km_priceField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.free_km_price, validators_free_km_price, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: status,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFree_kmsField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.free_kms, validators_free_kms, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: status,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurWaiting_rate_per_minField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.waiting_rate_per_min, validators_waiting_rate_per_min, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: status,
                                  free_duration: init.free_duration,
                                  base_fare: init.base_fare
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFree_durationField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.free_duration, validators_free_duration, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: status,
                                  base_fare: init.base_fare
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurBase_fareField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.base_fare, validators_base_fare, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  free_km_price: init.free_km_price,
                                  free_kms: init.free_kms,
                                  waiting_rate_per_min: init.waiting_rate_per_min,
                                  free_duration: init.free_duration,
                                  base_fare: status
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */5 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */5,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */6,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */8);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */7);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */6 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */7 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */8 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateFree_km_priceField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.free_km_price, state.submissionStatus, validators_free_km_price, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: status,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFree_kmsField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.free_kms, state.submissionStatus, validators_free_kms, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: status,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateWaiting_rate_per_minField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.waiting_rate_per_min, state.submissionStatus, validators_waiting_rate_per_min, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: status,
                                            free_duration: init.free_duration,
                                            base_fare: init.base_fare
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFree_durationField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.free_duration, state.submissionStatus, validators_free_duration, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: status,
                                            base_fare: init.base_fare
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateBase_fareField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, state.fieldsStatuses.base_fare, state.submissionStatus, validators_base_fare, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            free_km_price: init.free_km_price,
                                            free_kms: init.free_kms,
                                            waiting_rate_per_min: init.waiting_rate_per_min,
                                            free_duration: init.free_duration,
                                            base_fare: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */5 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */6 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */7 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateFree_km_price: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFree_km_priceField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateFree_kms: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFree_kmsField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateWaiting_rate_per_min: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateWaiting_rate_per_minField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateFree_duration: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFree_durationField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateBase_fare: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateBase_fareField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurFree_km_price: (function (param) {
              return Curry._1(dispatch, /* BlurFree_km_priceField */0);
            }),
          blurFree_kms: (function (param) {
              return Curry._1(dispatch, /* BlurFree_kmsField */1);
            }),
          blurWaiting_rate_per_min: (function (param) {
              return Curry._1(dispatch, /* BlurWaiting_rate_per_minField */2);
            }),
          blurFree_duration: (function (param) {
              return Curry._1(dispatch, /* BlurFree_durationField */3);
            }),
          blurBase_fare: (function (param) {
              return Curry._1(dispatch, /* BlurBase_fareField */4);
            }),
          free_km_priceResult: Formality.exposeFieldResult(state.fieldsStatuses.free_km_price),
          free_kmsResult: Formality.exposeFieldResult(state.fieldsStatuses.free_kms),
          waiting_rate_per_minResult: Formality.exposeFieldResult(state.fieldsStatuses.waiting_rate_per_min),
          free_durationResult: Formality.exposeFieldResult(state.fieldsStatuses.free_duration),
          base_fareResult: Formality.exposeFieldResult(state.fieldsStatuses.base_fare),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.free_km_price || match.free_kms || match.waiting_rate_per_min || match.free_duration || match.base_fare) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */5);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */6);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */7);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */7,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */8);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function isRupeeNegative(r) {
  return Currency.fromCurrency(r) < 0.0;
}

function getUnSignedRupee(r) {
  return Currency.toString(Currency.toCurrency(Math.abs(Currency.fromCurrency(r))));
}

function getInitialState(base_details, core_pricing) {
  if (base_details !== undefined) {
    return {
            base_fare: {
              base_value: Currency.fromCurrency(core_pricing.base_fare),
              delta: getUnSignedRupee(base_details.base_fare_delta),
              sign: Currency.fromCurrency(base_details.base_fare_delta) < 0.0 ? /* Decrement */1 : /* Increment */0
            },
            free_duration: {
              base_value: core_pricing.free_duration,
              delta: String(Math.abs(base_details.free_duration_delta)),
              sign: base_details.free_duration_delta < 0 ? /* Decrement */1 : /* Increment */0
            },
            waiting_rate_per_min: {
              base_value: Currency.fromCurrency(core_pricing.waiting_rate),
              delta: getUnSignedRupee(base_details.waiting_rate_per_min_delta),
              sign: Currency.fromCurrency(base_details.waiting_rate_per_min_delta) < 0.0 ? /* Decrement */1 : /* Increment */0
            },
            free_kms: {
              base_value: core_pricing.free_kms,
              delta: String(Math.abs(base_details.free_kms_delta)),
              sign: base_details.free_kms_delta < 0 ? /* Decrement */1 : /* Increment */0
            },
            free_km_price: {
              base_value: Currency.fromCurrency(core_pricing.free_km_price_per_min),
              delta: getUnSignedRupee(base_details.free_km_price_delta),
              sign: Currency.fromCurrency(base_details.free_km_price_delta) < 0.0 ? /* Decrement */1 : /* Increment */0
            }
          };
  } else {
    return {
            base_fare: {
              base_value: Currency.fromCurrency(core_pricing.base_fare),
              delta: "0",
              sign: /* Increment */0
            },
            free_duration: {
              base_value: core_pricing.free_duration,
              delta: "0",
              sign: /* Increment */0
            },
            waiting_rate_per_min: {
              base_value: Currency.fromCurrency(core_pricing.waiting_rate),
              delta: "0",
              sign: /* Increment */0
            },
            free_kms: {
              base_value: core_pricing.free_kms,
              delta: "0",
              sign: /* Increment */0
            },
            free_km_price: {
              base_value: Currency.fromCurrency(core_pricing.free_km_price_per_min),
              delta: "0",
              sign: /* Increment */0
            }
          };
  }
}

function getIntDisplayValue(input) {
  var v = FormValidationUtils$Catalyst.isIntegerStringValid(input.delta) ? Caml_format.caml_int_of_string(input.delta) : 0;
  var delta_value = input.sign === /* Increment */0 ? v : Math.imul(v, -1);
  return String(input.base_value + delta_value | 0);
}

function getFloatDisplayValue(input) {
  var v = FormValidationUtils$Catalyst.isFloatStringValid(input.delta) ? Number(input.delta) : 0.0;
  var delta_value = input.sign === /* Increment */0 ? v : v * -1.0;
  return (input.base_value + delta_value).toFixed(2);
}

function SimpleModificationBaseDetailsForm(Props) {
  var base_details = Props.base_details;
  var core_pricing = Props.core_pricing;
  var onNext = Props.onNext;
  var onBack = Props.onBack;
  var form = useForm(getInitialState(base_details, core_pricing), (function (output, param) {
          return Curry._1(onNext, {
                      base_fare_delta: output.base_fare,
                      free_duration_delta: output.free_duration,
                      waiting_rate_per_min_delta: output.waiting_rate_per_min,
                      free_kms_delta: output.free_kms,
                      free_km_price_delta: output.free_km_price
                    });
        }));
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  return React.createElement(React.Fragment, undefined, React.createElement(ModalBody.make, {
                  children: null
                }, React.createElement(SimpleModificationBaseDetailsForm$BaseDetailInput, {
                      sign: form.input.base_fare.sign,
                      delta: form.input.base_fare.delta,
                      value: getFloatDisplayValue(form.input.base_fare),
                      label: React.createElement(LabelUnit$Catalyst.make, {
                            label: "Base Fare",
                            unit: currency
                          }),
                      changeSign: (function (sign) {
                          var init = form.input.base_fare;
                          return Curry._2(form.updateBase_fare, (function (input, base_value) {
                                        return {
                                                base_fare: base_value,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: input.free_kms,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: init.delta,
                                      sign: sign
                                    });
                        }),
                      changeDelta: (function (delta) {
                          var init = form.input.base_fare;
                          return Curry._2(form.updateBase_fare, (function (input, base_value) {
                                        return {
                                                base_fare: base_value,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: input.free_kms,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: delta,
                                      sign: init.sign
                                    });
                        }),
                      result: form.base_fareResult
                    }), React.createElement(SimpleModificationBaseDetailsForm$BaseDetailInput, {
                      sign: form.input.free_duration.sign,
                      delta: form.input.free_duration.delta,
                      value: getIntDisplayValue(form.input.free_duration),
                      label: React.createElement(LabelUnit$Catalyst.make, {
                            label: "Free Duration",
                            unit: "min"
                          }),
                      changeSign: (function (sign) {
                          var init = form.input.free_duration;
                          return Curry._2(form.updateFree_duration, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: base_value,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: input.free_kms,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: init.delta,
                                      sign: sign
                                    });
                        }),
                      changeDelta: (function (delta) {
                          var init = form.input.free_duration;
                          return Curry._2(form.updateFree_duration, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: base_value,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: input.free_kms,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: delta,
                                      sign: init.sign
                                    });
                        }),
                      result: form.free_durationResult
                    }), React.createElement(SimpleModificationBaseDetailsForm$BaseDetailInput, {
                      sign: form.input.waiting_rate_per_min.sign,
                      delta: form.input.waiting_rate_per_min.delta,
                      value: getFloatDisplayValue(form.input.waiting_rate_per_min),
                      label: React.createElement(LabelUnit$Catalyst.make, {
                            label: "Waiting Rate per minute",
                            unit: currency + "/min"
                          }),
                      changeSign: (function (sign) {
                          var init = form.input.waiting_rate_per_min;
                          return Curry._2(form.updateWaiting_rate_per_min, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: base_value,
                                                free_kms: input.free_kms,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: init.delta,
                                      sign: sign
                                    });
                        }),
                      changeDelta: (function (delta) {
                          var init = form.input.waiting_rate_per_min;
                          return Curry._2(form.updateWaiting_rate_per_min, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: base_value,
                                                free_kms: input.free_kms,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: delta,
                                      sign: init.sign
                                    });
                        }),
                      result: form.waiting_rate_per_minResult
                    }), React.createElement(SimpleModificationBaseDetailsForm$BaseDetailInput, {
                      sign: form.input.free_kms.sign,
                      delta: form.input.free_kms.delta,
                      value: getIntDisplayValue(form.input.free_kms),
                      label: React.createElement(LabelUnit$Catalyst.make, {
                            label: "Free KMS",
                            unit: "km"
                          }),
                      changeSign: (function (sign) {
                          var init = form.input.free_kms;
                          return Curry._2(form.updateFree_kms, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: base_value,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: init.delta,
                                      sign: sign
                                    });
                        }),
                      changeDelta: (function (delta) {
                          var init = form.input.free_kms;
                          return Curry._2(form.updateFree_kms, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: base_value,
                                                free_km_price: input.free_km_price
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: delta,
                                      sign: init.sign
                                    });
                        }),
                      result: form.free_kmsResult
                    }), React.createElement(SimpleModificationBaseDetailsForm$BaseDetailInput, {
                      sign: form.input.free_km_price.sign,
                      delta: form.input.free_km_price.delta,
                      value: getFloatDisplayValue(form.input.free_km_price),
                      label: React.createElement(LabelUnit$Catalyst.make, {
                            label: "Price per minute for free KM",
                            unit: currency
                          }),
                      changeSign: (function (sign) {
                          var init = form.input.free_km_price;
                          return Curry._2(form.updateFree_km_price, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: input.free_kms,
                                                free_km_price: base_value
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: init.delta,
                                      sign: sign
                                    });
                        }),
                      changeDelta: (function (delta) {
                          var init = form.input.free_km_price;
                          return Curry._2(form.updateFree_km_price, (function (input, base_value) {
                                        return {
                                                base_fare: input.base_fare,
                                                free_duration: input.free_duration,
                                                waiting_rate_per_min: input.waiting_rate_per_min,
                                                free_kms: input.free_kms,
                                                free_km_price: base_value
                                              };
                                      }), {
                                      base_value: init.base_value,
                                      delta: delta,
                                      sign: init.sign
                                    });
                        }),
                      result: form.free_km_priceResult
                    })), React.createElement(ModalFooter.make, {
                  children: null
                }, React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Previous"
                          }, undefined, (function (param) {
                              return Curry._1(onBack, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Next"
                          }, !Curry._1(form.valid, undefined), (function (param) {
                              return Curry._1(form.submit, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn " + (
                            Curry._1(form.valid, undefined) ? "" : "e-disabled-btn"
                          ), undefined, undefined)
                    })));
}

var make = SimpleModificationBaseDetailsForm;

export {
  BaseDetailInput ,
  Form ,
  isRupeeNegative ,
  getUnSignedRupee ,
  getInitialState ,
  getIntDisplayValue ,
  getFloatDisplayValue ,
  make ,
  
}
/* react Not a pure module */
